import { CommunityContext } from '../contexts/contexts';

export const Community = ({ children, values }) => (
  <CommunityContext.Provider value={values}>
    {children}
  </CommunityContext.Provider>
);
